<div class="navbar-container" [class.example-is-mobile]="mobileQuery.matches">

  <!-- Top navbar -->
  <mat-toolbar class="navbar" color="primary">
    <button *ngIf="mobileQuery.matches" mat-icon-button (click)="sidenav.toggle()">
      <mat-icon>menu</mat-icon>
    </button>
    <button mat-button [matMenuTriggerFor]="userMenu" [disableRipple]="true" class="user-menu-button">
      <mat-icon style="color: #8b99b1;">arrow_drop_down</mat-icon>
      <div class="profile-img" [style.background-image]="'url('+imgSrc +')'"></div>
      <span fxShow fxHide.xs class="user-name">
        {{userName}}
      </span>
    </button>
    <mat-menu #userMenu="matMenu" xPosition="before" yPosition="above" [overlapTrigger]="false">
      <div mat-menu-item class="menu-item-inner-content" (click)="goToEditProfile()">
        {{'EDIT_PROFILE' | translate}}<mat-icon class="user-control-icons">account_circle</mat-icon>
      </div>
      <div mat-menu-item class="menu-item-inner-content" (click)="openEditPasswordDialog()">
         {{'EDIT_PASSWORD' | translate}}<mat-icon class="user-control-icons">lock</mat-icon>
      </div>
      <div mat-menu-item class="menu-item-inner-content" (click)="logout()">
        {{'LOGOUT' | translate}}<mat-icon class="user-control-icons">power_settings_new</mat-icon>
      </div>
    </mat-menu>

    <button mat-icon-button [matMenuTriggerFor]="notificationMenu" class="notif-button" style="transition:0.2s;">
      <mat-icon matBadge="{{notificationNumber > 0 ? notificationNumber : ''}}" matBadgeColor="accent"
        style="width: 0;z-index: 1;transition:0.2s;"></mat-icon>
      <img src="../assets/imgs/svg/ic_bell.svg" class="notification-icon-menu">
    </button>
    <mat-menu class="notifications" #notificationMenu="matMenu" xPosition="before" yPosition="above" [overlapTrigger]="false">

      <!-- <a mat-menu-item>
        <span>You have new tasks</span>
      </a>-->
      <div mat-menu-item  *ngIf="notificationsList.length == 0">
        <span>{{'NO_NOTIF' | translate}}</span>
      </div>
      <!--<div mat-menu-item *ngFor="let notif of notificationsList" (click)="notificationRedirection(notif.link)">
        <div class="notif-msg">{{notif.msg}}</div>
      </div>-->
      <div  class="notification-item-container" *ngFor="let element of notificationsList;let i = index">
        <div class="notification-header"  (click)="toggleNotification($event,i)"><mat-icon class="notification-header-arrow" [class.rotate-notification-arrow]="isToggledIn(i)">keyboard_arrow_down</mat-icon><div class="notif-badge">{{ element['notifs'].length }}</div>{{ "NOTIFICATION_HEADER." + element["type"] | translate }}</div>
        <div class="sub-notifications-container" [class.show-notification-list]="isToggledIn(i)">
          <div class="notification-item" *ngFor="let notif of element['notifs']" (click)="notificationRedirection(notif['link'])">{{ notif['msg'] }}</div>
        </div>
      </div>
    </mat-menu>

    <span class="navbar-spacer"></span>

    <a class="navbar-brand" style="display: flex;" [routerLink]="['/']">
      <img src="../assets/svg/logo-cnea.svg" alt="Logo" class="cnea-logo main-menu-logo" />
      <div class="republic-container" fxShow fxHide.xs>
        <h1 class="h1-header ministry-labe1">
          {{'REPUBLIQUE_TUNISIENNE' | translate}}
        </h1>
        <h1 class="h1-header ministry-labe2">
          {{'MINISTERE_AFFAIRES_SOCIALES' | translate}}
        </h1>
      </div>

    </a>
  </mat-toolbar>

  <mat-sidenav-container class="navbar-sidenav-container">
    <!-- Side nav -->
    <mat-sidenav #snav [opened]="!mobileQuery.matches" [mode]="mobileQuery.matches ? 'over' : 'side'"
      [fixedInViewport]="mobileQuery.matches" fixedTopGap="56" position="end"
      [ngClass]="mobileQuery.matches ? 'mobile-sidenav' : 'sidenav'">


      <div class="nav-list-item" [routerLink]="['/home/users']" *ngIf="canShowUserManagement()" routerLinkActive="active"
        style="margin-top: 10px;">
        <div style="transition:0.2s;" class="nav-item-img-container" [class.nav-item-img-container-selected]="activeRoute.users">
          <mat-icon  svgIcon="user-menu" inline="true" [class.active-menu]="activeRoute.users" class="inactive-menu"></mat-icon>
        </div>
        <div class="nav-item-label" [class.nav-item-label-selected]="activeRoute.users ? true : false">
          {{'USERS_MANAGEMENT' | translate }}</div>
      </div>

      <div class="nav-list-item" [routerLink]="['/home/apprenants']" *ngIf="canShowApprenantManagement()"
        routerLinkActive="active">
        <div class="nav-item-img-container" [class.nav-item-img-container-selected]="activeRoute.apprenants">
          <mat-icon  svgIcon="learner-menu" inline="true" [class.active-menu]="activeRoute.apprenants" class="inactive-menu"></mat-icon>
        </div>
        <div class="nav-item-label" [class.nav-item-label-selected]="activeRoute.apprenants ? true : false">
          {{'APPRENANTS_MANAGEMENT' | translate }}</div>
      </div>

      <div *ngIf="getSubMenusLengths().settings > 0" (mouseenter)="openSettingsMenu($event)"
        (mouseleave)="closeSettingsMenu($event)" class="nav-list-item">
        <div class="nav-item-img-container" [class.nav-item-img-container-selected]="activeRoute.settings">
          <mat-icon  svgIcon="setting-menu" inline="true" [class.active-menu]="activeRoute.settings" class="inactive-menu"></mat-icon>
        </div>
        <div class="nav-item-label" [class.nav-item-label-selected]="activeRoute.settings ? true : false">
          <span style="margin-right: 25px;">{{'SETTINGS' | translate }}</span>
          <mat-icon class="arrow-icon" [class.turn-arrow]="settingsMenu" style="margin-right: 5px;font-size: 26px !important;">
            <span id="openingSettingsMenuIcon" *ngIf="getSubMenusLengths().settings > 0">
              <span >arrow_drop_down</span>
            </span>
          </mat-icon>

        </div>
        <div #triggerSettings style="visibility: hidden; position: fixed" [style.left]="contextMenuPosition.x"
          [style.top]="contextMenuPosition.y" [matMenuTriggerFor]="contextMenu">
        </div>
        <mat-menu #contextMenu="matMenu" [hasBackdrop]="false" xPosition="before" yPosition="above"
          [overlapTrigger]="false">
          <div (mouseenter)="settingsMenuEntered()" (mouseleave)="settingsMenuLeaved()">
            <ng-template matMenuContent>
              <div *ngFor="let item of settingSubMenu">
                <button *ngIf="item.canShow" [routerLink]="item.routerLink" routerLinkActive="active" mat-menu-item
                  class="ss-menu-item" [class.ss-menu-item-selected]="item.isActiveRoute">
                  {{item.title | translate}}
                  <mat-icon class="ss-menu-icon">
                    settings
                  </mat-icon>
                </button>
              </div>


            </ng-template>
          </div>

        </mat-menu>
      </div>

      <div class="nav-list-item" routerLink="/home/groups" *ngIf="canShowGroupManagement()" routerLinkActive="active">
        <div class="nav-item-img-container" [class.nav-item-img-container-selected]="activeRoute.groups">
          <mat-icon  svgIcon="group-menu" inline="true" [class.active-menu]="activeRoute.groups" class="inactive-menu"></mat-icon>
        </div>

        <div class="nav-item-label" [class.nav-item-label-selected]="activeRoute.groups">
          {{'GROUPS_MANAGEMENT' | translate }}</div>
      </div>

      <div class="nav-list-item" [routerLink]="['/home/calendars']" routerLinkActive="active">
        <div class="nav-item-img-container" [class.nav-item-img-container-selected]="activeRoute.calendars">
          <mat-icon  svgIcon="calendar-menu" inline="true" [class.active-menu]="activeRoute.calendars" class="inactive-menu"></mat-icon>
        </div>

        <div class="nav-item-label" [class.nav-item-label-selected]="activeRoute.calendars">
          {{'CALENDARS_MANAGEMENT' | translate }}</div>
      </div>

      <!--   <mat-divider></mat-divider> -->

      <!-- <a id="push-bottom" mat-list-item>
          <mat-icon mat-list-icon>
            info_outline
          </mat-icon>
        </a> -->


    </mat-sidenav>

    <!-- Main content -->
    <mat-sidenav-content id="nav-bar-main" class="sidenav-content" [class.disable-click]="spinnerService.visibility.value">

      <div class="progress-bar-container">
        <mat-progress-bar color="accent" mode="indeterminate" *ngIf="spinnerService.visibility.value">
        </mat-progress-bar>
      </div>


      <router-outlet (activate)="resetPosition();">
      </router-outlet>

    </mat-sidenav-content>
  </mat-sidenav-container>

</div>